import { createFeatureSelector, createSelector } from '@ngrx/store';
import { USER_ROLES, AccountStatusEnum } from '~shared/constants/account-info.constant';
import { AccountTier, AccountTypeInfo, IAccountInformation } from '~shared/models/account-information.model';
import { USER_INFO_FEATURE_NAME } from './feature-name';
import { UserInfoState } from './user-info.state';

export const getUserState = createFeatureSelector(USER_INFO_FEATURE_NAME);
export const getUserPayload = createSelector(getUserState, (state: UserInfoState) => state && state.payload);
export const getUserData = createSelector(getUserPayload, (payload) => payload && payload.user);
export const getIsUserBlocked = createSelector(
  getUserData,
  (user) => user && user.status === AccountStatusEnum.blocked
);
export const isEntrepreneur = createSelector(
  getUserData,
  (userInfo: IAccountInformation) => userInfo && userInfo.role === USER_ROLES.entrepreneur
);
export const isAccountTier3 = createSelector(
  getUserData,
  (userInfo: IAccountInformation) => userInfo && userInfo.tier === AccountTier.TIER3
);
export const isSubsidiary = createSelector(
  getUserData,
  (userInfo: IAccountInformation) => userInfo && userInfo.accountType === AccountTypeInfo.SUBSIDIARY
);
